var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "popup-inner thx_modal" }, [
    _c("div", {
      staticClass: "popup-inner__close-popup js-close",
      on: {
        click: function($event) {
          return _vm.$emit("close")
        }
      }
    }),
    _c("div", { staticClass: "popup-inner__text-content" }, [
      _c("div", { staticClass: "g-row g-row--appearance_column" }, [
        _c("div", { staticClass: "el" }, [
          _c(
            "p",
            {
              staticClass:
                "ds-caption ds-caption--size_4xl-md ds-caption--size_2md ds-caption--w_sb ds-caption--c_blue tac"
            },
            [_vm._v(_vm._s(_vm.message.header))]
          )
        ]),
        _c("div", { staticClass: "el el--p_t_sm" }, [
          _c(
            "p",
            {
              staticClass:
                "ds-caption ds-caption--size_1md-md ds-caption--size_10xs ds-caption--w_m ds-caption--c_blue tac"
            },
            [_vm._v(_vm._s(_vm.message.text))]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3db4b5fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3db4b5fc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/app/Modals/ModalAnswer.vue
// module id = 91
// module chunks = 0